<template>
  <BTextField
    v-if="$attrs.disabled"
    v-bind="$attrs"
    :value="$attrs.value || '---'"
    v-on="$listeners"
  />
  <BAutocomplete
    v-else
    ref="autocomplete"
    v-bind="$attrs"
    :items="items"
    no-data-text="Список пуст"
    :request="request"
    :autoselect-on-blur="false"
    v-on="$listeners"
  >
    <template v-for="(_, key) in $scopedSlots" #[key]="props">
      <slot v-bind="props" :name="key" />
    </template>
  </BAutocomplete>
</template>

<script>
import { openApiMixin } from './mixins'
import {
  formsHandbookMapper as StoreMapper,
} from '@/views/FormsHandbook/store/cache'
import BAutocomplete from '../BAutocomplete.vue'
import BTextField from '@/components/forms/BTextField.vue'


export default {
  name: 'BAutocompleteSelectHandbook',
  components: {
    BTextField,
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  props: {
    handbook_id: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...StoreMapper.mapGetters(['getHandbookValues']),
    items() {
      const items = this.getHandbookValues(this.handbook_id) || []
      const { value } = this.$attrs

      if (
        typeof value !== 'undefined'
        && value !== null
        && !items.some((item) => item.id === value)
      ) {
        return [...items, { id: value, name: value }]
      }

      return items
    },
  },
  mounted() {
    this.focus()
  },
  methods: {
    ...StoreMapper.mapActions(['getOneById']),
    async request({ search } = { search: null }) {
      if (!this.handbook_id) return { data: [], meta: { count: 0 } }
      let { handbook_values: list } = await this.getOneById(this.handbook_id)

      if (search) {
        list = list.filter((o) => o.name.includes(search))
      }

      return { data: list, meta: { count: list.length } }
    },
  },
}
</script>
